module.exports = __webpack_public_path__ + "img/1455341025.90ecd92b.jpg";